import { CapacitorCookies } from '@capacitor/core';

import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { AppErrorResponse } from 'record-it-time-common/AppResponse';

import { ApiAdapter } from '../../../classes/ApiAdapter/ApiAdapter';
import { CookieUtils } from '../../../classes/misc/CookieUtils/CookieUtils';
import { useAuth } from '../../useAuth';

export function useLoginFunction({
  onError
}: {
  onError: (response: AppErrorResponse) => void;
}): (email: string, password: string) => Promise<void> {
  const { setAuthenticationData } = useAuth();

  return useEventCallback(async (email, password) => {
    const response = await ApiAdapter.login({
      email,
      password
    });

    const cookies = await CapacitorCookies.getCookies({
      url: CookieUtils.getApiCookiesUrl()
    });
    const csrfTokenCookie = cookies.csrftoken
      ? decodeURIComponent(cookies.csrftoken)
      : null;

    if (!response.success) {
      onError(response);
      return;
    }

    if (csrfTokenCookie) {
      await CapacitorCookies.deleteCookie({ key: 'csrftoken' });
      setAuthenticationData({
        csrfToken: csrfTokenCookie,
        userId: response.userId
      });
    } else {
      onError({
        success: false,
        error: 'NO_CSRF_TOKEN',
        message: 'No CSRF token received',
        details: []
      });
    }
  });
}
